import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDownWideShort, faArrowUpWideShort, faStar, faRulerHorizontal, faFolder } from '@fortawesome/free-solid-svg-icons';

const FILTER_OPTIONS = [
  { value: 'featured', label: 'Featured', icon: faStar },
  { value: 'cheap', label: 'Low to High Price', icon: faArrowUpWideShort },
  { value: 'expensive', label: 'High to Low Price', icon: faArrowDownWideShort },
];

const BoatListFilter = ({ 
  selected, 
  onChange, 
  onMoreFilterClick, 
  filterBySizeBtnRef, 
  sizeFilterActive, 
  sizeFilter,
  onCategoryFilterClick,
  categoryFilter,
  showCategoryModal,
  filterByCategoryBtnRef
}) => {
  // Determinar si algún filtro de precio debe estar activo
  // Solo si NO hay filtros de tamaño o categoría activos
  const shouldShowPriceFilterActive = !sizeFilter && !categoryFilter;

  // Obtener el objeto de rango para mostrar el label correcto
  const SIZE_RANGES = [
    { label: '21ft - 40ft', range: '21-40' },
    { label: '41ft - 60ft', range: '41-60' },
    { label: '61ft - 79ft', range: '61-79' },
    { label: '80ft and up', range: '80+' },
  ];
  const sizeFilterObj = SIZE_RANGES.find(r => sizeFilter === r.range) || null;

  return (
    <div className="boat-list-filter-checkbox-row">
      {FILTER_OPTIONS.map(option => (
        <button
          key={option.value}
          className={
            'boat-list-filter-checkbox-btn' +
            (selected === option.value && shouldShowPriceFilterActive ? ' boat-list-filter-checkbox-btn--active' : '')
          }
          type="button"
          onClick={() => onChange(option.value)}
        >
          <FontAwesomeIcon icon={option.icon} />
          {option.label}
        </button>
      ))}
      
      <button
        className={
          'boat-list-filter-checkbox-btn boat-list-filter-checkbox-btn--more-filter' +
          (sizeFilter ? ' boat-list-filter-checkbox-btn--active' : '')
        }
        type="button"
        onClick={onMoreFilterClick}
        ref={filterBySizeBtnRef}
      >
        <FontAwesomeIcon icon={faRulerHorizontal} />
        {sizeFilterObj ? `Size: ${sizeFilterObj.range}` : 'By Size'}
      </button>
      
      <button
        className={
          'boat-list-filter-checkbox-btn boat-list-filter-checkbox-btn--more-filter' +
          (categoryFilter ? ' boat-list-filter-checkbox-btn--active' : '')
        }
        type="button"
        onClick={onCategoryFilterClick}
        ref={filterByCategoryBtnRef}
      >
        <FontAwesomeIcon icon={faFolder} />
        {categoryFilter ? categoryFilter.name : 'By Category'}
      </button>
    </div>
  );
};

export default BoatListFilter;
